export default function About() {
  return (
    <section id="about" className="py-24 px-6 bg-gradient-to-b from-[#0a0f1c] to-[#1a1a1a]">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Side - Image */}
          <div className="relative group">
            <div className="rounded-[40px] overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/bac3ba9896f5c022063dcb7cbe117b1d.jpg"
                alt="Master Jae Production Recording Studio Interior in Tumahole Parys"
                title="Professional Music Studio Equipment - Master Jae Production"
                className="w-full h-full object-cover object-top transform group-hover:scale-105 transition-transform duration-700"
              />
            </div>
          </div>

          {/* Right Side - Content */}
          <div>
            <div className="inline-block bg-[#00d9ff]/10 border border-[#00d9ff] text-[#00d9ff] px-6 py-2 rounded-full text-sm font-semibold tracking-wider mb-6">
              ABOUT MASTER JAE PRODUCTION
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
              CRAFTING SONIC & VISUAL<br />
              <span className="text-gray-400">EXCELLENCE SINCE DAY ONE</span>
            </h2>

            <p className="text-gray-400 text-lg leading-relaxed mb-6">
              Based in <strong>Tumahole, Parys</strong>, <strong>Master Jae Production</strong> has been delivering professional <strong>multimedia services</strong> since 2006. We specialize in <strong>music production</strong>, <strong>graphic design</strong>, and <strong>post-production services</strong>, helping artists and businesses bring their creative visions to life with exceptional quality and professionalism.
            </p>

            <p className="text-gray-400 text-lg leading-relaxed mb-8">
              Our studio combines cutting-edge equipment with years of industry experience. Whether you need <strong>recording</strong>, <strong>mixing</strong>, <strong>mastering</strong>, <strong>brand identity design</strong>, or <strong>audio post-production</strong>, we provide personalized service and attention to detail that ensures your project stands out. Your vision, professionally crafted.
            </p>

            <div className="grid grid-cols-3 gap-6 mb-8">
              <div className="text-center">
                <div className="text-4xl font-black text-[#ff6b35] mb-2">500+</div>
                <div className="text-gray-400 text-sm">Projects Completed</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-black text-[#00d9ff] mb-2">300+</div>
                <div className="text-gray-400 text-sm">Happy Clients</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-black text-[#d4af37] mb-2">24/7</div>
                <div className="text-gray-400 text-sm">Support Available</div>
              </div>
            </div>

            <button className="bg-gray-800 text-white px-8 py-4 rounded-lg hover:bg-gray-700 transition-all duration-300 font-medium flex items-center space-x-2 group cursor-pointer whitespace-nowrap">
              <span>LEARN MORE ABOUT US</span>
              <i className="ri-arrow-right-up-line group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
